module.exports = __webpack_public_path__ + "static/media/icon_menu_mobile.7916860a.svg";